import './popup.scss'

import React from 'react'
import classNames from 'classnames'
import { isArray } from 'lodash'
import { ReactComponent as CloseIcon } from './close.svg'

export default class Popup extends React.Component {
  _handle(handler, dismissed = false) {
    if (this.props.onClose) this.props.onClose(dismissed)
    if (handler) handler(dismissed)
  }

  render() {
    return (
      <div className="popup-overlay">
        <div className="popup-underlay">
          <div
            className={classNames(
              'popup',
              this.props.className,
              this.props.size
            )}
          >
            {(this.props.closable === undefined || this.props.closable) && (
              <button
                className="popup-close"
                onClick={() => this._handle(null, true)}
              >
                <CloseIcon />
              </button>
            )}

            <div className="popup-content">
              <h2 className="popup-title">{this.props.title}</h2>
              {this.props.subtitle && (
                <div className="popup-subtitle">{this.props.subtitle}</div>
              )}
              <div
                className={classNames(
                  'popup-body',
                  'body',
                  { icon: !!this.props.iconClass },
                  this.props.iconClass
                )}
              >
                {this.props.icon && (
                  <div className="popup-icon"
                    className={classNames(
                      'popup-icon',
                      this.props.inlineIconClass
                    )}>
                    {this.props.icon}
                  </div>
                )}
                {this.props.text
                  ? isArray(this.props.text)
                    ? this.props.text.map((text, index) => (
                      <div key={index}>{text}</div>
                    ))
                    : this.props.text
                  : this.props.children}
              </div>
            </div>
            {this.props.buttons && this.props.buttons.length && (
              <div className="popup-buttons">
                {this.props.buttons.map((button, index) => (
                  <button
                    key={index}
                    className={classNames('button', {
                      secondary: button.secondary,
                    })}
                    disabled={button.disabled}
                    onClick={() => this._handle(button.handler)}
                  >
                    {button.text}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }
}
